// @TODO maybe move this somewhere else

const newToast = toast => ({
    id: Date.now(),
    ...toast
});

const state = {
    toasts: []
};

const mutations = {
    PUSH_TOAST(state, toast) {
        state.toasts.unshift(toast);
    },
    POP_TOAST(state, id) {
        state.toasts = state.toasts.filter(toast => toast.id !== id);
    }
};

const actions = {
    pushToast({ commit }, toast) {
        commit('PUSH_TOAST', newToast(toast));
    },
    removeToast({ commit }, id) {
        commit('POP_TOAST', id);
    }
};

export default {
    state,
    mutations,
    actions
};
